import { FIELD_MARGIN_METRIC_MAX, OBSTACLE_SAFETY_DISTANCE_METRIC_MAX } from '../../constants';
import { feetToMeters } from 'utils/distanceUtil';

import type { UseImperialHandlersParams, UseImperialHandlersReturn } from './types';

const useImperialHandlers = ({
    onUpdate
}: UseImperialHandlersParams): UseImperialHandlersReturn => {
    const handleFieldMarginChange: UseImperialHandlersReturn['handleFieldMarginChange'] = ({
        value
    }) => onUpdate({ fieldMargin: Math.min(feetToMeters(value), FIELD_MARGIN_METRIC_MAX) });

    const handleObstacleSafetyChange: UseImperialHandlersReturn['handleObstacleSafetyChange'] = ({
        value
    }) =>
        onUpdate({
            obstacleSafetyDistance: Math.min(
                feetToMeters(value),
                OBSTACLE_SAFETY_DISTANCE_METRIC_MAX
            )
        });

    return { handleFieldMarginChange, handleObstacleSafetyChange };
};

export default useImperialHandlers;
